import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function PainPoints() {
  const points = [{
    problem: 'Buscás material práctico de mantenimiento para tus alumnos',
    consequence: 'Todo está en inglés, es de nivel universitario o no tiene nada que ver con la secundaria técnica argentina'
  }, {
    problem: 'Querés enseñar diagnóstico de fallas desde casos reales',
    consequence: 'No encontrás material progresivo que conecte la teoría con el taller real'
  }, {
    problem: 'Armás tus checklists y actividades desde cero',
    consequence: 'Cada semana. Cada año. Sin que nadie lo vea ni lo valore'
  }, {
    problem: 'Tus evaluaciones son improvisadas',
    consequence: 'Sin criterios claros ni rúbricas para trabajos prácticos de taller'
  }, {
    problem: 'La teoría no conecta con las máquinas reales',
    consequence: 'Los alumnos no entienden para qué sirve lo que aprenden'
  }, {
    problem: 'Domingo, 11 de la noche',
    consequence: 'El cursor parpadea en un Word en blanco y mañana hay 6 horas de taller'
  }];
  return <section className="py-8 md:py-12 px-3 bg-brand-bordo" data-id="element-160">
      <div className="max-w-4xl mx-auto" data-id="element-161">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-4 text-white leading-tight uppercase text-shadow-lg" data-id="element-162">
          💣 ¿CUÁNTOS DOMINGOS MÁS VAS A PERDER ASÍ?
        </h2>

        <p className="text-sm md:text-lg text-white mb-6 text-center max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-163">
          Sos docente de mantenimiento, electromecánica o maestro de taller en
          una escuela técnica industrial. Sabés lo que es pararte frente a 25
          pibes que van a trabajar en plantas reales cuando egresen. Sabés lo
          que es querer darles lo mejor.
          <br data-id="element-164" />
          <br data-id="element-165" />
          <span className="text-brand-accent font-black text-lg md:text-xl bg-black/30 px-2 py-1 rounded" data-id="element-166">
            Pero nadie te dio un sistema pensado para la realidad del taller
            técnico argentino.
          </span>
        </p>

        <div className="bg-brand-dark rounded-xl border-2 border-brand-accent overflow-hidden mb-6 shadow-2xl" data-id="element-167">
          <div className="grid grid-cols-2 bg-brand-accent text-black font-black text-xs md:text-base text-center uppercase" data-id="element-168">
            <div className="p-3 border-r-2 border-brand-dark" data-id="element-169">
              Lo que intentás hacer
            </div>
            <div className="p-3" data-id="element-170">Lo que encontrás</div>
          </div>
          <div className="divide-y divide-white/10" data-id="element-171">
            {points.map((point, index) => <div key={index} className="grid grid-cols-2 hover:bg-white/5 transition-colors" data-id="element-172">
                <div className="p-3 md:p-4 border-r border-white/10 flex items-start" data-id="element-173">
                  <AlertTriangle className="w-4 h-4 text-brand-accent mr-2 shrink-0 mt-0.5" data-id="element-174" />
                  <p className="text-xs md:text-sm text-white font-bold" data-id="element-175">
                    {point.problem}
                  </p>
                </div>
                <div className="p-3 md:p-4 flex items-start" data-id="element-176">
                  <p className="text-xs md:text-sm text-gray-300 font-medium" data-id="element-177">
                    {point.consequence}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center mb-4" data-id="element-178">
          <p className="text-lg md:text-2xl font-black text-brand-accent neon-glow uppercase" data-id="element-179">
            👉 No es falta de vocación. Es falta de un sistema.
          </p>
        </div>

        <div className="text-center" data-id="element-180">
          <h3 className="text-xl md:text-3xl font-black text-white uppercase text-shadow-lg" data-id="element-181">
            💡 ¿Y SI ESTE FUERA EL ÚLTIMO DOMINGO ASÍ?
          </h3>
        </div>
      </div>
    </section>;
}